import SpotCurrentConditions from './SpotCurrentConditions';

export default SpotCurrentConditions;
